export default __webpack_public_path__ + "static/media/cryptocap.23ef6f44.svg";